import apiFetch from '../../api-fetch';
import Toast from '../../toast';
import { sendSlackNotification } from '../../functions';
import Sentry from '../../sentry';
import axiosSend from './axiosSend';

const uploadFile = async (
  file,
  setIsUploading = () => {},
  setUploadProgress = () => {},
  destinationBucket = 'MovementVideoBucket',
) => {
  const parts = file.name.split('.');
  const fileExtension = parts[parts.length - 1].toLowerCase();
  // console.devLog.info('File extension:', fileExtension);

  try {
    const { filename, url } = await apiFetch({
      url: 'Client/GetUploadURL',
      method: 'GET',
      query: { fileExtension, destinationBucket },
    });

    try {
      // Figure out how to properly upload larger files to S3 here

      // https://docs.aws.amazon.com/AmazonS3/latest/dev/PresignedUrlUploadObject.html
      // Example: https://github.com/minio/cookbook/blob/master/docs/presigned-put-upload-via-browser.md

      const fetchResult = await axiosSend(url, file, setUploadProgress);

      // console.devLog.info('fetch result:', fetchResult);
      // Return the filename if response was successful
      if (fetchResult && fetchResult.status === 200) {
        return filename;
      }

      return null;
    } catch (er) {
      console.devLog.info('Error uploading file to AWS:', er);
      Toast.error('Error uploading file to AWS.');
      setIsUploading(false);
      setUploadProgress(0);
      sendSlackNotification(
        `Error uploading media in TWA chat (check sentry): ${er}`,
      );
      Sentry.captureException(er, {
        extra: {
          ...file,
        },
      });
      setIsUploading(false);
      setUploadProgress(0);
      throw new Error(er);
    }
  } catch (e) {
    console.devLog.info('Error getting upload URL:', e);
    // Toast.error('Error getting upload URL');
    Sentry.captureException(e, {
      extra: {
        ...file,
      },
    });
    throw new Error(e);
    return null;
  }
};

export default uploadFile;
